export default __webpack_public_path__ + "static/media/ssprints.bb7ec75f.mp4";